/* cart-effects.js
   Fly-to-cart effect for Dutchshopper theme
   Targets:
   - product cards: <product-card>
   - add action: button[aria-label="plus"] inside <quantity-input data-mode="qatc">
   - cart bubble: #header--cart-bubble
*/

(function () {
  const DEBUG = true;

  function log(...args) {
    if (DEBUG) console.log("[cart-effects]", ...args);
  }

  function getCartTarget() {
    // Use the actual clickable element inside the cart bubble as target
    const bubble = document.querySelector("#header--cart-bubble");
    if (!bubble) return null;

    // Prefer the <a> within it
    const link = bubble.querySelector('a[href="/cart"]') || bubble.querySelector("a");
    return link || bubble;
  }

  function getProductImage(productCardEl) {
    if (!productCardEl) return null;

    // In your markup, image is within picture > img
    const img =
      productCardEl.querySelector("picture img") ||
      productCardEl.querySelector("img");

    return img || null;
  }

  function createFlyImage(fromImgEl) {
    const rect = fromImgEl.getBoundingClientRect();
    const fly = fromImgEl.cloneNode(true);

    fly.classList.add("ds-fly-item");
    fly.removeAttribute("srcset"); // avoid responsive swapping issues
    fly.removeAttribute("sizes");

    // Force current rendered src
    // (if lazyloaded, it already has src; if not, still ok)
    fly.style.position = "fixed";
    fly.style.left = rect.left + "px";
    fly.style.top = rect.top + "px";
    fly.style.width = rect.width + "px";
    fly.style.height = rect.height + "px";
    fly.style.objectFit = "contain";
    fly.style.zIndex = "999999";
    fly.style.pointerEvents = "none";
    fly.style.borderRadius = "12px";
    fly.style.opacity = "0.95";
    fly.style.transform = "translate3d(0,0,0) scale(1)";
    fly.style.transition =
      "transform 650ms cubic-bezier(.2,.9,.2,1), opacity 650ms ease";

    document.body.appendChild(fly);
    return fly;
  }

  function animateFlyToCart(fromImgEl) {
    const target = getCartTarget();
    if (!target) {
      log("No cart target found (#header--cart-bubble).");
      return;
    }

    const fly = createFlyImage(fromImgEl);

    const fromRect = fly.getBoundingClientRect();
    const toRect = target.getBoundingClientRect();

    // Aim for center of cart target
    const toX = toRect.left + toRect.width / 2;
    const toY = toRect.top + toRect.height / 2;

    // Start point center
    const fromX = fromRect.left + fromRect.width / 2;
    const fromY = fromRect.top + fromRect.height / 2;

    const dx = toX - fromX;
    const dy = toY - fromY;

    requestAnimationFrame(() => {
      fly.style.transform = `translate3d(${dx}px, ${dy}px, 0) scale(0.15)`;
      fly.style.opacity = "0.2";
    });

    // Pop cart a bit
    const bubble = document.querySelector("#header--cart-bubble");
    if (bubble) {
      bubble.classList.add("ds-cart-pop");
      setTimeout(() => bubble.classList.remove("ds-cart-pop"), 350);
    }

    fly.addEventListener(
      "transitionend",
      () => {
        fly.remove();
      },
      { once: true }
    );
  }

  function isPlusButton(el) {
    return (
      el &&
      el.matches &&
      el.matches('button[aria-label="plus"], button[aria-label="Plus"], button[aria-label="+"]')
    );
  }

  function onClick(e) {
    // We capture clicks anywhere and check if it was the plus button (or inside it)
    const btn = e.target.closest && e.target.closest('button[aria-label="plus"]');
    if (!btn || !isPlusButton(btn)) return;

    // Must be inside a quantity-input with data-mode="qatc"
    const qty = btn.closest("quantity-input[data-mode='qatc']");
    if (!qty) return;

    // Must be inside a product-card
    const productCard = btn.closest("product-card");
    if (!productCard) {
      log("Plus clicked but no <product-card> ancestor found.");
      return;
    }

    const img = getProductImage(productCard);
    if (!img) {
      log("No product image found in product-card.");
      return;
    }

    log("Trigger fly-to-cart for:", productCard.getAttribute("data-handle") || "(unknown)");
    animateFlyToCart(img);
  }

  function injectCSS() {
    // Minimal CSS for pop effect (optional, safe)
    if (document.getElementById("ds-cart-effects-css")) return;
    const style = document.createElement("style");
    style.id = "ds-cart-effects-css";
    style.textContent = `
      #header--cart-bubble.ds-cart-pop {
        transform: translate3d(0,0,0) scale(1.08);
        transition: transform 250ms ease;
      }
    `;
    document.head.appendChild(style);
  }

  function init() {
    injectCSS();

    // Use capture=true so we catch it even if something stops propagation later
    document.addEventListener("click", onClick, true);
    log("Initialized. Watching for plus button clicks.");
    log("Cart target:", getCartTarget());
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
